export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/ob-step-8.png?def072c3f9ddebece248a5e0cb021be3";